var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuture3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "white",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 14.9998C20.0871 14.9998 20.8333 14.2536 20.8333 13.3332C20.8333 12.4127 20.0871 11.6665 19.1667 11.6665C18.2462 11.6665 17.5 12.4127 17.5 13.3332C17.5 14.2536 18.2462 14.9998 19.1667 14.9998Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 18.3333C25.9206 18.3333 26.6668 17.5871 26.6668 16.6667C26.6668 15.7462 25.9206 15 25.0002 15C24.0797 15 23.3335 15.7462 23.3335 16.6667C23.3335 17.5871 24.0797 18.3333 25.0002 18.3333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 24.9998C27.5871 24.9998 28.3333 24.2536 28.3333 23.3332C28.3333 22.4127 27.5871 21.6665 26.6667 21.6665C25.7462 21.6665 25 22.4127 25 23.3332C25 24.2536 25.7462 24.9998 26.6667 24.9998Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 18.3335C18.0473 18.3335 18.5891 18.4413 19.0946 18.6507C19.6002 18.8601 20.0595 19.167 20.4464 19.5539C20.8333 19.9408 21.1402 20.4001 21.3496 20.9056C21.559 21.4112 21.6668 21.953 21.6668 22.5002V25.4168C21.6666 26.1139 21.4167 26.7878 20.9625 27.3165C20.5082 27.8453 19.8797 28.1938 19.1906 28.2991C18.5016 28.4044 17.7976 28.2594 17.2062 27.8904C16.6148 27.5214 16.1751 26.9528 15.9668 26.2877C15.6112 25.1404 14.8612 24.3891 13.7168 24.0335C13.0519 23.8253 12.4836 23.3859 12.1146 22.795C11.7456 22.204 11.6003 21.5005 11.705 20.8117C11.8097 20.1229 12.1576 19.4944 12.6855 19.0398C13.2135 18.5853 13.8868 18.3347 14.5834 18.3335H17.5001Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture3);
export default __webpack_public_path__ + "static/media/future-3.b59a23871c21f784d2fa59c24cb25886.svg";
export { ForwardRef as ReactComponent };